export const rippleResult = (rippleResult = null, action) => {
    if (action.type === "FETCH_RIPPLE_RESULT") {
        return action.payload;
    }
    return rippleResult;
};